import React, { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { getLink, getLinkFromRef } from '../../../utility/index.js'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import './heroBanner.css'
import { HeroBanner } from './HeroBanner.jsx'

export const BannerConnect = ({ page, component }) => {
  // process page and compoenent parameters here and pass the to Banner
  const _models = component.getModels()
  const { document: _documentRef } = _models
  const document = _documentRef && page.getContent(_documentRef)
  const data = document?.getData() || {}
  const imageUrl = page.getContent(data?.image?.$ref)?.getOriginal()?.getUrl()
  const mobileImageUrl = page
    .getContent(data?.mobileImage?.image?.$ref)
    ?.getOriginal()
    ?.getUrl()
  const bgImageUrl = page
    .getContent(data?.bgImage?.image?.$ref)
    ?.getOriginal()
    ?.getUrl()
  const params = component?.getParameters()

  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const mediaQuery = matchMedia('(max-width: 768px)')
    setIsMobile(mediaQuery.matches)
    const handleChange = (event) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  const {
    angleBorder,
    angleBorderColor,
    angleType,
    backgroundColor,
    columnCount,
    contentAlignment,
    eyebrowColor,
    eyebrowFont,
    secondaryHeadingColor,
    textColor,
    verticalPadding,
    width,
    horizontalCrop,
    verticalCrop,
    marginTop,
    marginBottom,
    backgroundPosition,
    backgroundSize,
  } = params

  const componentProps = {
    angleBorder,
    angleBorderColor,
    angleType,
    backgroundColor,
    columnCount,
    contentAlignment,
    eyebrowColor,
    secondaryHeadingColor,
    textColor,
    verticalPadding,
    width,
    horizontalCrop,
    verticalCrop,
    marginBottom,
    marginTop,
    backgroundPosition,
    backgroundSize,
  }

  const documentProps = {
    bgImageUrl: bgImageUrl,
    eyebrowFont: eyebrowFont,
    eyebrowText: data?.eyebrowText,
    imageUrl: imageUrl,
    mobileImageUrl: mobileImageUrl,
    primaryHeading:
      data?.title && typeof data?.title === 'object'
        ? data?.title?.value
        : data?.title || '',
    secondaryHeading: data?.subtitle,
    linkList: data?.links
      ?.filter((l) => l.link && l.link.length > 0)
      ?.map((l) => getLink(getLinkFromRef(l, page), null)),
  }

  const args = {
    ...componentProps,
    ...documentProps,
    isMobile: isMobile,
  }
  return (
    <div className="heroBanner u-posRelative">
      {document && <BrManageContentButton content={document} />}
      <HeroBanner {...args} />
    </div>
  )
}
function BannerErrorBoundary(props) {
  return (
    <ErrorBoundary
      fallback={<div></div>}
      onError={(error, info) => {
        console.log('BannerErrorBoundary error:', error, info)
      }}
    >
      <BannerConnect {...props}></BannerConnect>
    </ErrorBoundary>
  )
}

export default BannerErrorBoundary
